// Magyarország 19 megyéje + Budapest, ahogy a regisztrációs és szűrő felületeken megjelenik.
export const COUNTIES = [
  'Budapest',
  'Baranya',
  'Bács-Kiskun',
  'Békés',
  'Borsod-Abaúj-Zemplén',
  'Csongrád-Csanád',
  'Fejér',
  'Győr-Moson-Sopron',
  'Hajdú-Bihar',
  'Heves',
  'Jász-Nagykun-Szolnok',
  'Komárom-Esztergom',
  'Nógrád',
  'Pest',
  'Somogy',
  'Szabolcs-Szatmár-Bereg',
  'Tolna',
  'Vas',
  'Veszprém',
  'Zala',
];

// A regisztrációs "lefedettségi terület" választóban a fenti lista elé kerülő pszeudo-opció.
export const HUNGARIAN_COUNTIES = ['Magyarország teljes területe', ...COUNTIES];

// URL-barát megyenév, a backend utils/slugify.js toSlug-jával egyezően: "Borsod-Abaúj-Zemplén" → "borsod-abauj-zemplen".
export const countySlug = (county) =>
  county
    .toLowerCase()
    .replace(/[áàäâ]/g, 'a')
    .replace(/[éèëê]/g, 'e')
    .replace(/[íìïî]/g, 'i')
    .replace(/[óòöôő]/g, 'o')
    .replace(/[úùüûű]/g, 'u')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

// A Provider.county vesszővel elválasztott lista ("Pest,Fejér" vagy "Magyarország teljes területe");
// az első valós megye, vagy null (országos / üres / ismeretlen érték)
export const primaryCounty = (countyField) =>
  (countyField || '').split(',').map((c) => c.trim()).find((c) => COUNTIES.includes(c)) || null;

// URL-paraméterből (megyenév vagy slug) a megye neve; ismeretlen értéknél null.
export const findCountyByParam = (param) =>
  COUNTIES.find((county) => county === param || countySlug(county) === param) || null;
